import React from "react";

import i18n from "../../locale/i18n";
import {TableData} from '@euroland/react-table';
import { SETTING_FORMAT, TOOL_TEMPLATE } from "../../constant/common";
import { useCompanySettings, useSelectedInstrument, useTemplateSetting } from "../../hooks/useCompanySettings";
import { useInstrument } from "../../hooks/useInstruments";
import { useAmountInvested } from "../../hooks/useTrades";
import { formatDateTime, replaceKey } from "../../utils";
import { getCurrencyLabel } from "../../store/utils";
import { formatDate } from '@euroland/libs';
import useCurrencyName from '../../hooks/useCurrencyName';

const createTableData = ({ data, currencyCode, template, format, getCurrencyNameByCode, formatNumber }) => {
  let header, body;
  switch (template) {
    case TOOL_TEMPLATE.victor:
      header = {
        volume: {
          children: `${i18n.translate("value") + " (" + currencyCode + ")"}`,
          "aria-label": `${i18n.translate("value")} ${getCurrencyNameByCode(currencyCode)}`
        },
        sharePrice: {
          children: `${i18n.translate("perShare") + " (" + currencyCode + ")"}`,
          "aria-label": `${i18n.translate("perShare")} ${getCurrencyNameByCode(currencyCode)}`
        },
        sharesBought: {
          children: i18n.translate("sharesPurchased"),
        },
      };
      body = data.map(item => {
        return {
          volume: {
            children: formatNumber(item.initialValue, format),
            align: "right",
          },
          sharePrice: {
            children: formatNumber(item.initialPrice, format),
            align: "right",
          },
          sharesBought: {
            children: formatNumber(item.shareBought, {decimalDigits: 0}),
            align: "right",
          },
        };
      });
      break;
    case TOOL_TEMPLATE.quadrata:
      header = {
        volume: {
          children: `${i18n.translate("value") + " (" + currencyCode + ")"}`,
        },
        sharePrice: {
          children: `${i18n.translate("sharePrice") + " (" + currencyCode + ")"}`,
        },
        sharesBought: {
          children: i18n.translate("sharesBought"),
        },
      };
      body = data.map(item => {
        return {
          volume: {
            children: formatNumber(item.initialValue, format),
            align: "right",
          },
          sharePrice: {
            children: formatNumber(item.initialPrice, format),
            align: "right",
          },
          sharesBought: {
            children: formatNumber(item.shareBought, {decimalDigits: 0}),
            align: "right",
          },
        };
      });
      break;
    default:
      break;
  }

  return { header, body };
};

function InitialinvestmentCard() {
  const [{ amountInvested, query }] = useAmountInvested();
  const [{ selectedInstrument }] = useInstrument();
  const companySettings = useCompanySettings();
  const template = useTemplateSetting();
  const getCurrencyNameByCode = useCurrencyName();
  const [, { formatNumber }] = useSelectedInstrument();


  const { header, body } = createTableData({
    data: [amountInvested],
    currencyCode: getCurrencyLabel(query.currency || selectedInstrument.currencyCode),
    template,
    getCurrencyNameByCode,
    formatNumber
  });
  let key = "";
  switch (template) {
    case TOOL_TEMPLATE.victor:
      key = "initialInvestmentWithBrackets";
      break;
    case TOOL_TEMPLATE.quadrata:
      key = "initialInvestmentWithHyphen";
      break;
    default:
      break;
  }
  const caption = replaceKey(i18n.translate(key), [formatDate(amountInvested.initialDate, SETTING_FORMAT.FULL_DATE)])

  const newBody = Object.entries(header).map(([key, label]) => {
    const value = body[0][key];
    return {
      label, value
    }
  })
  
  const newHeader = {
    label: { children: 'Label'},
    value: { children: 'value'}
  }

  return (
    <>
      <div className="initialinvestment-card">
        <h2 className="initialinvestment-card__heading" aria-hidden="true">
          {replaceKey(i18n.translate(key), [formatDateTime(amountInvested.initialDate, companySettings)])}
        </h2>
        <TableData
          className="initialinvestment-card__table"
          design="table-quadrata"
          hiddenHeader={false}
          hiddenFooter={false}
          body={newBody}
          header={newHeader}
          headerLeft={false}
          caption={caption}
          containerProps={{}}
        ></TableData>
      </div>
    </>
  );
}

export default InitialinvestmentCard;
